import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5ded780"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "user-columns-page" }
const _hoisted_2 = {
  key: 0,
  class: "loading-wrapper"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loading",
  src: "/static/image/column3_bx_loader.gif"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_columns = _resolveComponent("user-columns")!
  const _component_user_corporate_layout = _resolveComponent("user-corporate-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createVNode(_component_user_corporate_layout, {
      "user-id": _ctx.userId,
      "medium-id": _ctx.mediumId,
      onFetchedUserAccount: _cache[0] || (_cache[0] = () => { _ctx.loading = false; })
    }, {
      default: _withCtx(({ userAccount }) => [
        _createVNode(_component_user_columns, {
          class: "content-section",
          "user-account-id": _ctx.userId,
          limit: 10
        }, null, 8, ["user-account-id"])
      ]),
      _: 1
    }, 8, ["user-id", "medium-id"])
  ]))
}